import type * as React from 'react';
import { connect } from 'react-redux';
import { search, showSearch } from 'state/actions/search';
import { getTerm, getShown as getSearchBarShown } from 'state/selectors/search';
import { createSelector } from 'reselect';
import { SearchTextboxDumb } from './search-textbox-dumb';
import { editingHelpCenter } from 'state/actions/help-center-preview';

const selector = createSelector(getTerm, getSearchBarShown, (term, searchBarShown) => ({
    searchBarShown,
    value: term,
}));

export default connect(selector, {
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => search(e.target.value, { show: false }),
    onSearch: () => showSearch(true),
    closeCustomizeSidebar: () => editingHelpCenter(false),
})(SearchTextboxDumb);
